import { render, staticRenderFns } from "./CotizacionDetail.vue?vue&type=template&id=3ffe43dd&scoped=true&"
import script from "./CotizacionDetail.vue?vue&type=script&lang=js&"
export * from "./CotizacionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe43dd",
  null
  
)

export default component.exports